import { Control, Controller } from 'react-hook-form';
import { IonIcon, IonInput, IonItem, IonLabel, IonRow, IonSkeletonText, IonSpinner, IonText } from '@ionic/react';
import { caretDownOutline } from 'ionicons/icons';
import { useState } from 'react';

import { WrapperDiv } from './FormSelectable.styles';
import FormSelectableModal from './FormSelectableModal';

interface IComponentProps {
  control: Control<any, object>;
  name: string;

  label?: string;
  placeholder?: string;

  fieldKey?: string;
  itemKey: string;
  itemValue: string;
  itemValueSub?: string;
  items: any[];

  itemsLoading?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  iconColor?: string;
  showLoading?: boolean;
  allowSearch?: boolean;
  flexFill?: boolean;

  itemDisabled?: (item: any) => boolean;

  handleClick?: () => void;
  handleSelection?: (value: any) => void;
  handleSearch?: (arg: string) => void;
  handleDismiss?: () => void;
}

const FormSelectable: React.FC<IComponentProps> = ({
  control,
  name,
  label,
  placeholder,
  fieldKey,
  itemKey,
  itemValue,
  itemValueSub,
  items,
  itemsLoading,
  isLoading,
  disabled,
  iconColor,
  showLoading,
  allowSearch,
  flexFill,
  itemDisabled,
  handleClick,
  handleSelection,
  handleSearch,
  handleDismiss,
}) => {
  const [showModal, setShowModal] = useState(false);
  const fieldKeyClone = fieldKey || 'code';

  const handleInputClick = () => {
    handleClick && handleClick();
    setShowModal(true);
  };

  const getMatchingItem = (fieldValue: any) => {
    const fieldKeyValue = fieldValue[fieldKeyClone] as string | boolean | number;
    if ((fieldValue || fieldKeyValue === false || fieldKeyValue === 0) && items?.length) {
      const matchingItem = items.find((item) => {
        return item[itemKey] === fieldKeyValue;
      });
      return matchingItem || {};
    }
    return {};
  };

  const getFieldDisplay = (fieldValue: any) => {
    if (fieldValue !== undefined) {
      const matchingItem = getMatchingItem(fieldValue);
      return matchingItem[itemValue]?.toString() || fieldValue[fieldKeyClone];
    }
    return '';
  };

  return (
    <Controller
      control={control}
      name={name || ''}
      render={({ field, fieldState: { error } }) => {
        let fieldClone = { ...field };
        if (field.value) {
          if (!fieldKey) {
            fieldClone.value = {
              [fieldKeyClone]: field.value[fieldKeyClone] || field.value,
            };
          }
        }

        return (
          <WrapperDiv>
            <IonRow className="form-row">
              {isLoading ? (
                <IonItem className={flexFill || flexFill === undefined ? 'ion-no-padding flexed-fill' : 'ion-no-padding'}>
                  <IonLabel position="stacked">{label}</IonLabel>
                  <IonSkeletonText animated />
                  <IonIcon className="icon" icon={caretDownOutline} slot="end" color={iconColor || 'medium'} />
                  {error && <IonText className="error">{error.message}</IonText>}
                </IonItem>
              ) : (
                <IonItem onClick={() => handleInputClick()} className={flexFill || flexFill === undefined ? 'ion-no-padding flexed-fill' : 'ion-no-padding'} disabled={disabled}>
                  <IonInput placeholder={placeholder} readonly value={getFieldDisplay(fieldClone.value)} label={label} labelPlacement="stacked" />
                  {itemsLoading && <IonSpinner slot="end" name="lines-small" />}
                  <IonIcon className="icon" icon={caretDownOutline} slot="end" color={iconColor || 'medium'} />
                  {error && <IonText className="error">{error.message}</IonText>}
                </IonItem>
              )}
            </IonRow>

            <FormSelectableModal
              field={fieldClone}
              fieldKey={fieldKey}
              itemKey={itemKey}
              itemValue={itemValue}
              itemValueSub={itemValueSub}
              placeholder={placeholder}
              allowSearch={allowSearch}
              handleDismiss={() => {
                setShowModal(false);
                handleDismiss && handleDismiss();
              }}
              handleSearch={handleSearch}
              handleSelection={(val) => {
                setShowModal(false);
                handleSelection && handleSelection(val);
              }}
              itemDisabled={itemDisabled}
              items={items}
              showLoading={showLoading}
              showModal={showModal}
            />
          </WrapperDiv>
        );
      }}
    />
  );
};

export default FormSelectable;
